export const MULTI_ROOM_UNSUITABLE_TOUR_OPERATORS: Array<string> = ['COR', 'FER', 'FOR', 'LMX', 'LMXI', 'LMXF', 'LMIF', 'SIT', 'WFT'];



// WEBPACK FOOTER //
// ./src/app/shared/help/multi-room.ts